import { useMemo } from 'react';

import type { AnalyticsDataPoint } from '../../components/ChartContainer';
import { aggregateByGranularity } from '../../utils/aggregateByGranularity';

export function useStraightSale(
    map: Map<string, { revenue: number; saleCount: number }> | undefined,
    granularity: 'daily' | 'weekly' | 'monthly',
    currency: string,
): AnalyticsDataPoint[] {
    return useMemo(() => {
        if (!map) return [];
        const data = Array.from(map.entries())
            .map(([code, { revenue, saleCount }]) => ({ code, value: revenue, volume: saleCount, currency }))
            .sort((a, b) => new Date(a.code).getTime() - new Date(b.code).getTime());
        return aggregateByGranularity(data, granularity);
    }, [map, currency, granularity]);
}
